// 3rd-party modules
import { message } from 'antd';
import { SubmitHandler, useForm } from 'react-hook-form';
import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { yupResolver } from '@hookform/resolvers/yup';

// project modules
import { apiCall } from '../../helpers/apiHelper';
import Loader from "../shared/loader";
import Popup from '../shared/popup/popup';
import { RootState } from '../../stores';
import yup from '../../plugins/yup';
import Input, { Password } from "../shared/inputs/input";


// apis
// import * as AccountApi from '../../apis/accountApi';
import * as AuthApi from '../../apis/authApi';

// models
import { AccountKiboshDevice } from '../../models/accountKiboshDevice';
import { ApiResponse } from '../../models/response';
import { changeEmailViewModel } from '../../models/types/auth';

type Props = {
  closeOnSave?: boolean;
  modalTitle?: string;
  open: boolean;
  showUsername?: boolean;
  user: any;
  onClose?: () => void;
  onSave?: (user: any) => void;
};

export default function ChangeEmailModal({ closeOnSave = false, modalTitle = "", open, showUsername = false, user, onClose, onSave }: Props) {
  const kiboshDevice = useSelector((state: RootState) => state.user.kiboshDevice) || new AccountKiboshDevice();
  const schema = yup.object().shape({
    newEmail: yup.string().label("New Email").required().max(500),
  });
  const { handleSubmit, reset, control } = useForm<changeEmailViewModel | any>({
    defaultValues: useMemo(() => user, [user]),
    resolver: yupResolver(schema),
  });
  const [loading, setLoading] = useState(false);
  const abortController = new AbortController();

  useEffect(() => {
    if (open) {
      reset(); // this is to make sure form clears on new while undefined props ignored by react-hook-form
    }
  }, [open]);

  const onCancel = () => {
    abortController.abort();

    if(onClose) onClose();
  };

  const onSubmit: SubmitHandler<changeEmailViewModel> = async (formData: changeEmailViewModel) => {

    setLoading(true);
    let response: ApiResponse;

    if (formData.newEmail) {

      response = await apiCall(AuthApi.requestEmailChange({ newEmail: formData.newEmail }, abortController.signal));


      if (response.success)
        message.success('Email Change Confirmation Sent Successfully.');
      else
        message.error('Email Change Failed.');
    }

    if (onSave) onSave(response!.data?.value);

    if (closeOnSave) {
      open = false;

      onCancel();
    }

    setLoading(false);
  };

  return (
    <Popup
      title={ modalTitle || `Change Email${showUsername ? ` - Username: ${user.username}` : ""}`}
      onCancel={onCancel}
      fixSize="auto"
      onClose={onCancel}
      onSave={handleSubmit(onSubmit)}>
      { loading &&
        <Loader />
      }
          <view>
            <view data-scroll>
                <group data-background="" data-space="15"  data-gap="10" data-direction="column">
                  <Input
                    control={control}
                    name="newEmail"
                    label="New Email"
                    dataLength="auto"
                    size="large"
                  />
                </group>
            </view>
          </view>
    </Popup>
  );
}
